<template>
  <!-- Main sidebar -->
  <div class="sidebar sidebar-main" :class="loggedInUserData.is_staff ? 'sidebar-admin' : 'cus-sidebar'">
    <div class="sidebar-content">
      <!-- Main navigation for STAFF -->
      <div
        class="sidebar-category sidebar-category-visible"
        v-if="loggedInUserData.is_staff || showAdminSections"
      >
        <button @click="toggleAllNavigations" class="toggle-nav-btn">
          <i class="fa fa-caret-down mr-1" :class="{ 'rotated': allNavigationsExpanded }"></i>
          {{ $t('sidebar.toggleAllNavigations') }}
        </button>
        <div class="category-content no-padding">
          <ul class="navigation navigation-main navigation-accordion">
            <!-- Main -->
            <!-- <li class="navigation-header">
              <span>Main</span> <i class="icon-menu" title="Main pages"></i>
            </li> -->
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="loggedInUserData.is_staff"
              to="/dashboard"
              tag="li"
              active-class="active"
            ><a style="font-size: 15px; font-weight: bold;">
              <i style="font-size: 18px; flex-shrink: 0;" class="material-icons">dashboard</i>
              <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.dashboard')) }}</span><span v-if="$_restWords($t('sidebar.dashboard'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.dashboard')) }}</span></span>
            </a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_statistics_dashboard')"
              to="/statistics"
              tag="li"
              active-class="active"
            ><a style="font-size: 15px; font-weight: bold;">
              <i style="font-size: 18px; flex-shrink: 0;" class="material-icons">bar_chart</i>
              <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.statisticsDashboard')) }}</span><span v-if="$_restWords($t('sidebar.statisticsDashboard'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.statisticsDashboard')) }}</span></span>
            </a></router-link>
            <div v-if="hasAnyOrdersSectionPerm" class="sidebar-user-material orders">
              <div class="category-content pt-0" style="background-color:#16182EFF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.orders"
                    @click.prevent="toggleSection('orders')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.orders')) }}</span><span v-if="$_restWords($t('sidebar.orders'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.orders')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.orders"
              >
                <ul class="navigation" style="background-color:#2C315BFF;">
                  <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_ship_only') && $_status_visible('ship_only')"
              to="/ship-only"
              tag="li"
              active-class="active"
                ><a> <i
                      style="font-size: 16px"
                      class="fa fa-plus"
                    /> <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('ship_only')) }}</span><span v-if="$_restWords($_status_label('ship_only'))" class="oc-nav-label-line">{{ $_restWords($_status_label('ship_only')) }}</span></span>
                  <span v-if="orderCounts && orderCounts.ship_only > 0" class="badge order-badge">{{ orderCounts.ship_only }}</span>
                  </a></router-link>
                  <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_all_order')"
                  to="/all-order"
                  tag="li"
                  active-class="active"
                ><a> <i
                      style="font-size: 16px"
                      class="fa fa-cubes"
                    ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.allOrdersTitle')) }}</span><span v-if="$_restWords($t('orders.allOrdersTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.allOrdersTitle')) }}</span></span>
                  <span v-if="orderCounts && orderCounts.all_orders > 0" class="badge order-badge">{{ orderCounts.all_orders }}</span>
                </a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_new_order') && $_status_visible('new_order')"
                  to="/new-order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                        style="font-size: 18px"
                        class="material-icons"
                      >add_box</i>
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('new_order')) }}</span><span v-if="$_restWords($_status_label('new_order'))" class="oc-nav-label-line">{{ $_restWords($_status_label('new_order')) }}</span></span>
                    <span v-if="orderCounts && orderCounts.new_order > 0" class="badge order-badge order-badge--green">{{ orderCounts.new_order }}</span>
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_pending_answer_order') && $_status_visible('pending_answer')"
                  to="/pending-answer-order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 16px"
                      class="fa fa-adn"
                    />
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('pending_answer')) }}</span><span v-if="$_restWords($_status_label('pending_answer'))" class="oc-nav-label-line">{{ $_restWords($_status_label('pending_answer')) }}</span></span>
                    <span v-if="orderCounts && orderCounts.pending_answer > 0" class="badge order-badge">{{ orderCounts.pending_answer }}</span>
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_processed_order') && $_status_visible('processed_order')"
                  to="/processed_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 16px"
                      class="fa fa-cog"
                    /><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('processed_order')) }}</span><span v-if="$_restWords($_status_label('processed_order'))" class="oc-nav-label-line">{{ $_restWords($_status_label('processed_order')) }}</span></span>
                  <span v-if="orderCounts && orderCounts.processed_order > 0" class="badge order-badge">{{ orderCounts.processed_order }}</span>
                </a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_canceled_order') && $_status_visible('canceled')"
                  to="/canceled_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 16px"
                      class="fa fa-times"
                    /><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('canceled')) }}</span><span v-if="$_restWords($_status_label('canceled'))" class="oc-nav-label-line">{{ $_restWords($_status_label('canceled')) }}</span></span>
                  <span v-if="orderCounts && orderCounts.canceled > 0" class="badge order-badge">{{ orderCounts.canceled }}</span>
                </a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_approved_order') && $_status_visible('approved_order')"
                  to="/approved_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 16px"
                      class="fa fa-check"
                    /><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('approved_order')) }}</span><span v-if="$_restWords($_status_label('approved_order'))" class="oc-nav-label-line">{{ $_restWords($_status_label('approved_order')) }}</span></span>
                  <span v-if="orderCounts && orderCounts.approved_order > 0" class="badge order-badge">{{ orderCounts.approved_order }}</span>
                </a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_refunded_order') && $_status_visible('refunded')"
                  to="/refunded_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >block</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('refunded')) }}</span><span v-if="$_restWords($_status_label('refunded'))" class="oc-nav-label-line">{{ $_restWords($_status_label('refunded')) }}</span></span>
                  <span v-if="orderCounts && orderCounts.refunded > 0" class="badge order-badge">{{ orderCounts.refunded }}</span>
                </a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_partial_refund')"
                  to="/secret?component=partial-refund"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      class="fa fa-file-text-o"
                      style="font-size: 16px"
                    />
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.partialRefundTooltip')) }}</span><span v-if="$_restWords($t('orders.partialRefundTooltip'))" class="oc-nav-label-line">{{ $_restWords($t('orders.partialRefundTooltip')) }}</span></span>
                    <span v-if="orderCounts && orderCounts.partial_refund > 0" class="badge order-badge">{{ orderCounts.partial_refund }}</span>
                  </a>
                </router-link>
                <router-link
                  v-if="$_has_perm('view_purchased_order') && $_status_visible('purchased')"
                  class="sidebar-mobile-main-toggle"
                  to="/purchased_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >add_shopping_cart</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('purchased')) }}</span><span v-if="$_restWords($_status_label('purchased'))" class="oc-nav-label-line">{{ $_restWords($_status_label('purchased')) }}</span></span>
                  <span v-if="orderCounts && orderCounts.purchased > 0" class="badge order-badge">{{ orderCounts.purchased }}</span>
                </a></router-link>
                <router-link
                  v-if="$_has_perm('view_warehouse_delivered_order') && $_status_visible('warehouse_delivered_order')"
                  class="sidebar-mobile-main-toggle"
                  to="/warehouse_delivered_order"
                  tag="li"
                  active-class="active"
                ><a>
                    <i
                      style="font-size: 16px"
                      class="fa fa-wordpress"
                    ></i> <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('warehouse_delivered_order')) }}</span><span v-if="$_restWords($_status_label('warehouse_delivered_order'))" class="oc-nav-label-line">{{ $_restWords($_status_label('warehouse_delivered_order')) }}</span></span>
                  <span v-if="orderCounts && orderCounts.warehouse_delivered_order > 0" class="badge order-badge">{{ orderCounts.warehouse_delivered_order }}</span>
                </a></router-link>
                <router-link
                  v-if="$_has_perm('view_pending_to_shipment_order') && $_status_visible('pending_to_shipment')"
                  class="sidebar-mobile-main-toggle"
                  to="/pending_to_shipment_order"
                  tag="li"
                  active-class="active"
                ><a><span class="pending-boat-icon">
    <i class="material-icons boat-base">directions_boat</i>
    <i class="material-icons boat-badge">schedule</i>
  </span>
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('pending_to_shipment')) }}</span><span v-if="$_restWords($_status_label('pending_to_shipment'))" class="oc-nav-label-line">{{ $_restWords($_status_label('pending_to_shipment')) }}</span></span>
                  <span v-if="orderCounts && orderCounts.pending_to_shipment > 0" class="badge order-badge">{{ orderCounts.pending_to_shipment }}</span>
                </a></router-link>
                <router-link
                  v-if="$_has_perm('view_shipment_order') && $_status_visible('int_shipment')"
                  class="sidebar-mobile-main-toggle"
                  to="/int_shipment_order"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >directions_boat</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('int_shipment')) }}</span><span v-if="$_restWords($_status_label('int_shipment'))" class="oc-nav-label-line">{{ $_restWords($_status_label('int_shipment')) }}</span></span>
                  <span v-if="orderCounts && orderCounts.int_shipment > 0" class="badge order-badge">{{ orderCounts.int_shipment }}</span>
                </a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_pending_to_branch') && $_status_visible('pending_to_branch')"
                  to="/pending_to_branch_order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 18px"
                      class="fa fa-product-hunt"
                    />
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('pending_to_branch')) }}</span><span v-if="$_restWords($_status_label('pending_to_branch'))" class="oc-nav-label-line">{{ $_restWords($_status_label('pending_to_branch')) }}</span></span>
                    <span v-if="orderCounts && orderCounts.pending_to_branch > 0" class="badge order-badge">{{ orderCounts.pending_to_branch }}</span>
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_branch_delivered_order') && $_status_visible('branch_delivery')"
                  to="/branch_delivery_order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 18px"
                      class="material-icons"
                    >local_shipping</i>
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('branch_delivery')) }}</span><span v-if="$_restWords($_status_label('branch_delivery'))" class="oc-nav-label-line">{{ $_restWords($_status_label('branch_delivery')) }}</span></span>
                    <span v-if="orderCounts && orderCounts.branch_delivery > 0" class="badge order-badge">{{ orderCounts.branch_delivery }}</span>
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_delivered_order') && $_status_visible('delivered')"
                  to="/user-delivered-order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 18px"
                      class="material-icons"
                    >
                      local_taxi
                    </i>
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('delivered')) }}</span><span v-if="$_restWords($_status_label('delivered'))" class="oc-nav-label-line">{{ $_restWords($_status_label('delivered')) }}</span></span>
                    <span v-if="orderCounts && orderCounts.delivered > 0" class="badge order-badge">{{ orderCounts.delivered }}</span>
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_archived_order') && $_status_visible('archived')"
                  to="/admin-archived-order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 18px"
                      class="material-icons"
                    >
                      archive
                    </i>
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('archived')) }}</span><span v-if="$_restWords($_status_label('archived'))" class="oc-nav-label-line">{{ $_restWords($_status_label('archived')) }}</span></span>
                    <span v-if="orderCounts && orderCounts.archived > 0" class="badge order-badge">{{ orderCounts.archived }}</span>
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_damage_order') && $_status_visible('damage')"
                  to="/damage_order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 18px"
                      class="material-icons"
                    >
                      broken_image
                    </i>
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('damage')) }}</span><span v-if="$_restWords($_status_label('damage'))" class="oc-nav-label-line">{{ $_restWords($_status_label('damage')) }}</span></span>
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_return_order') && $_status_visible('return')"
                  to="/return_order"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 18px"
                      class="material-icons"
                    >
                      assignment_return
                    </i>
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('return')) }}</span><span v-if="$_restWords($_status_label('return'))" class="oc-nav-label-line">{{ $_restWords($_status_label('return')) }}</span></span>
                  </a>
                </router-link>
                </ul>
              </div>
            </div>

            <!-- Tools (moved out of Orders: exportable orders, warehouse date-passed,
            not-found orders, purchase history -- secondary/reference views, not order
            statuses) -->
            <div v-if="hasAnyToolsSectionPerm" class="sidebar-user-material tools">
              <div class="category-content pt-0" style="background-color:#37474FFF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.tools"
                    @click.prevent="toggleSection('tools')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.tools')) }}</span><span v-if="$_restWords($t('sidebar.tools'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.tools')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.tools"
              >
                <ul class="navigation" style="background-color:#455A64FF;">
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_exportable_order')"
                  to="/exportable-order"
                  tag="li"
                  active-class="active"
                ><a>
                    <i
                      style="font-size: 16px"
                      class="fa fa-file-excel-o"
                    ></i> <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.exportableOrdersTitle')) }}</span><span v-if="$_restWords($t('orders.exportableOrdersTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.exportableOrdersTitle')) }}</span></span></a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_warehouse_passed_order')"
                  to="/warehouse-date-passed"
                  tag="li"
                  active-class="active"
                ><a>
                    <i
                      style="font-size: 16px"
                      class="fa fa-calendar"
                    ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('shipOnly.warehousePassedLabel')) }}</span><span v-if="$_restWords($t('shipOnly.warehousePassedLabel'))" class="oc-nav-label-line">{{ $_restWords($t('shipOnly.warehousePassedLabel')) }}</span></span></a></router-link>
                    <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_not_found_order')"
                  to="/not-found-orders"
                  tag="li"
                  active-class="active"
                >
                  <a>
                    <i
                      style="font-size: 16px"
                      class="fa fa-eye-slash"
                    />
                    <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.notFoundOrdersTitle')) }}</span><span v-if="$_restWords($t('orders.notFoundOrdersTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.notFoundOrdersTitle')) }}</span></span>
                  </a>
                </router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_purchase_history')"
                  to="/purchase-history"
                  tag="li"
                  active-class="active"
                ><a> <i
                      style="font-size: 16px"
                      class="fa fa-clock-o"
                    ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.purchaseHistoryTitle')) }}</span><span v-if="$_restWords($t('orders.purchaseHistoryTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.purchaseHistoryTitle')) }}</span></span></a></router-link>
                </ul>
              </div>
            </div>

            <!-- Export Orders -->
            <div v-if="hasAnyExportOrderSectionPerm" class="sidebar-user-material export-order">
              <div class="category-content pt-0" style="background-color:#7A8088FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.export"
                    @click.prevent="toggleSection('export')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.export')) }}</span><span v-if="$_restWords($t('sidebar.export'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.export')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.export"
              >
                <ul class="navigation" style="background-color:#9EA6B0FF;">
                  <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_export_order')"
              to="/export-order/pending"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-plus"
                />
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.newExportOrdersTitle')) }}</span><span v-if="$_restWords($t('orders.newExportOrdersTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.newExportOrdersTitle')) }}</span></span>
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_processed_export_order')"
              to="/export-order/processed"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-cog"
                />
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('adminDashboard.processedLabel')) }}</span><span v-if="$_restWords($t('adminDashboard.processedLabel'))" class="oc-nav-label-line">{{ $_restWords($t('adminDashboard.processedLabel')) }}</span></span>
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_canceled_export_order')"
              to="/export-order/canceled"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-times"
                />
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('common.canceledStatus')) }}</span><span v-if="$_restWords($t('common.canceledStatus'))" class="oc-nav-label-line">{{ $_restWords($t('common.canceledStatus')) }}</span></span>
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_approved_export_order')"
              to="/export-order/approved"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-check"
                />
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.approvedStatusTitle')) }}</span><span v-if="$_restWords($t('orders.approvedStatusTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.approvedStatusTitle')) }}</span></span>
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_sent_export_order')"
              to="/export-order/sent"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-plane"
                />
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.sentStatusTitle')) }}</span><span v-if="$_restWords($t('orders.sentStatusTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.sentStatusTitle')) }}</span></span>
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_received_export_order')"
              to="/export-order/received"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-check-circle"
                />
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('finance.received')) }}</span><span v-if="$_restWords($t('finance.received'))" class="oc-nav-label-line">{{ $_restWords($t('finance.received')) }}</span></span>
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_export_history')"
              to="/export-order/export-history"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-history"
                />
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.exportHistoryTitle')) }}</span><span v-if="$_restWords($t('orders.exportHistoryTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.exportHistoryTitle')) }}</span></span>
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_export_order_refund') && $_status_visible('refunded')"
              to="/export-order/refunded"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-undo"
                />
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($_status_label('refunded')) }}</span><span v-if="$_restWords($_status_label('refunded'))" class="oc-nav-label-line">{{ $_restWords($_status_label('refunded')) }}</span></span>
              </a>
            </router-link>
                </ul>
              </div>
            </div>

            <hr class="my-0" />
            <div v-if="hasAnyDeliverySectionPerm" class="sidebar-user-material delivery">
              <div class="category-content pt-0" style="background-color:#731212FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.delivery"
                    @click.prevent="toggleSection('delivery')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.delivery')) }}</span><span v-if="$_restWords($t('sidebar.delivery'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.delivery')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.delivery"
              >
                <ul class="navigation" style="background-color:#912121FF;">
                  <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_order_delivery')"
              to="/order-delivery"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-motorcycle"
                />
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('delivery.orderDeliveryTitle')) }}</span><span v-if="$_restWords($t('delivery.orderDeliveryTitle'))" class="oc-nav-label-line">{{ $_restWords($t('delivery.orderDeliveryTitle')) }}</span></span>
              </a>
            </router-link>
                </ul>
              </div>
            </div>
            <hr
              v-if="$_has_perm('view_not_found_order') || $_has_perm('view_order_case')"
              class="my-0"
            />
            <hr class="my-0" />

            <div v-if="hasAnyInvoicesSectionPerm" class="sidebar-user-material invoices">
              <div class="category-content pt-0" style="background-color:#927805FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.invoices"
                    @click.prevent="toggleSection('invoices')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.invoices')) }}</span><span v-if="$_restWords($t('sidebar.invoices'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.invoices')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.invoices"
              >
                <ul class="navigation" style="background-color:#AE8F09FF;">
                <router-link
                class="sidebar-mobile-main-toggle"
                v-if="$_has_perm('view_shipping_invoice')"
                to="/order_invoice"
                tag="li"
                active-class="active"
              ><a><i
                    class="fa fa-file-text-o"
                    style="font-size: 16px"
                  ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('invoice.shippingInvoiceTitle')) }}</span><span v-if="$_restWords($t('invoice.shippingInvoiceTitle'))" class="oc-nav-label-line">{{ $_restWords($t('invoice.shippingInvoiceTitle')) }}</span></span></a></router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                v-if="$_has_perm('view_order_invoice')"
                to="/secret?component=credit-log-transaction"
                tag="li"
                active-class="active"
              ><a><i
                    class="fa fa-file-text-o"
                    style="font-size: 16px"
                  ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('invoice.ordersInvoiceTitle')) }}</span><span v-if="$_restWords($t('invoice.ordersInvoiceTitle'))" class="oc-nav-label-line">{{ $_restWords($t('invoice.ordersInvoiceTitle')) }}</span></span></a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_credit')"
                  to="/secret?component=credit-log-action"
                  tag="li"
                  active-class="active"
                ><a><i
                      class="fa fa-file-text-o"
                      style="font-size: 16px"
                    ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('invoice.creditInvoiceTitle')) }}</span><span v-if="$_restWords($t('invoice.creditInvoiceTitle'))" class="oc-nav-label-line">{{ $_restWords($t('invoice.creditInvoiceTitle')) }}</span></span></a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_delivery_invoice')"
                  to="/secret?component=delivery-invoice"
                  tag="li"
                  active-class="active"
                ><a><i
                      class="fa fa-motorcycle"
                      style="font-size: 16px"
                    ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('delivery.deliveryInvoiceTitle')) }}</span><span v-if="$_restWords($t('delivery.deliveryInvoiceTitle'))" class="oc-nav-label-line">{{ $_restWords($t('delivery.deliveryInvoiceTitle')) }}</span></span></a></router-link>
                </ul>
              </div>
            </div>


            <hr class="my-0" />
            <!-- <li v-if="$_has_perm('')">
              <a href=""><i style="font-size: 18px" class="material-icons">swap_horiz</i><span>Transactions</span></a>
              <ul>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/secret?component=credit-log-transaction"
                  tag="li"
                  active-class="active"
                ><a>Order Invoice</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/secret?component=credit-log-action"
                  tag="li"
                  active-class="active"
                ><a>Credit</a></router-link>
              </ul>
            </li> -->
              <div v-if="hasAnyFinanceSectionPerm" class="sidebar-user-material finance">
              <div class="category-content pt-0" style="background-color:#3E8195FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.finance"
                    @click.prevent="toggleSection('finance')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.finance')) }}</span><span v-if="$_restWords($t('sidebar.finance'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.finance')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.finance"
              >
                <ul class="navigation" style="background-color:#4C9EB8;">
                  <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_expense')"
              to="/secret?component=expense"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-eur"
                  style="font-size: 16px"
                ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('finance.expensesTitle')) }}</span><span v-if="$_restWords($t('finance.expensesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('finance.expensesTitle')) }}</span></span></a></router-link>
                  <!-- [COMMENTED - Banks menu hidden, managed internally] -->
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_bank')"
                    to="/banks"
                    tag="li"
                    active-class="active"
                  ><a><i
                        style="font-size: 18px"
                        class="material-icons"
                      >account_balance</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('finance.banksTitle')) }}</span><span v-if="$_restWords($t('finance.banksTitle'))" class="oc-nav-label-line">{{ $_restWords($t('finance.banksTitle')) }}</span></span></a>
                  </router-link>

                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_bank_transaction')"
                    to="/bank-transactions"
                    tag="li"
                    active-class="active"
                  ><a><i
                        style="font-size: 18px"
                        class="material-icons"
                      >receipt</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('finance.bankTransactionsTitle')) }}</span><span v-if="$_restWords($t('finance.bankTransactionsTitle'))" class="oc-nav-label-line">{{ $_restWords($t('finance.bankTransactionsTitle')) }}</span></span></a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_currency_rate')"
                    to="/currency-rate"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 18px"
                        class="material-icons"
                      >
                        loop
                      </i>
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('finance.currencyRatesTitle')) }}</span><span v-if="$_restWords($t('finance.currencyRatesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('finance.currencyRatesTitle')) }}</span></span>
                    </a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_profit')"
                    to="/secret?component=profit"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-pie-chart"
                        style="font-size: 16px"
                      ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('profit.title')) }}</span><span v-if="$_restWords($t('profit.title'))" class="oc-nav-label-line">{{ $_restWords($t('profit.title')) }}</span></span></a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_capital')"
                    to="/secret?component=capital"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-database"
                        style="font-size: 16px"
                      ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('finance.capitalTitle')) }}</span><span v-if="$_restWords($t('finance.capitalTitle'))" class="oc-nav-label-line">{{ $_restWords($t('finance.capitalTitle')) }}</span></span></a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_money_transfer')"
                    to="/secret?component=money-transfer"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-share"
                        style="font-size: 16px"
                      ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('finance.moneyTransfersTitle')) }}</span><span v-if="$_restWords($t('finance.moneyTransfersTitle'))" class="oc-nav-label-line">{{ $_restWords($t('finance.moneyTransfersTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_expense_type')"
                    to="/secret?component=expense-type"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-file-text"
                        style="font-size: 16px"
                      ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('finance.expenseTypesTitle')) }}</span><span v-if="$_restWords($t('finance.expenseTypesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('finance.expenseTypesTitle')) }}</span></span></a></router-link>
                </ul>
              </div>
            </div>
            <!-- <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_exchange_rate')"
              to="/exchange-rate"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >loop</i>Exchange rates</a></router-link> -->
            <!-- <router-link
              v-if="$_has_perm('view_branch')"
              class="sidebar-mobile-main-toggle"
              to="/branch"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  class="fa fa-home pl-2"
                  style="font-size: 16px"
                />
                Branches
              </a>
            </router-link> -->

            <hr
              class="my-0"
            />

            <div v-if="hasAnyCasesSectionPerm" class="sidebar-user-material cases">
              <div class="category-content pt-0" style="background-color:#7A5A3EFF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.cases"
                    @click.prevent="toggleSection('cases')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.cases')) }}</span><span v-if="$_restWords($t('sidebar.cases'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.cases')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.cases"
              >
                <ul class="navigation" style="background-color:#956D4B;">
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_order_case')"
                    to="/order-cases"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 16px"
                        class="fa fa-folder-open"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.orderCasesTitle')) }}</span><span v-if="$_restWords($t('orders.orderCasesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.orderCasesTitle')) }}</span></span>
                    </a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_progress_order_case') || $_has_perm('view_order_case')"
                    to="/order-case-progress"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 16px"
                        class="fa fa-folder-open"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.orderCasesProgressTitle')) }}</span><span v-if="$_restWords($t('sidebar.orderCasesProgressTitle'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.orderCasesProgressTitle')) }}</span></span>
                    </a>
                  </router-link>
                </ul>
              </div>
            </div>

            <div v-if="hasAnyCustomersSectionPerm" class="sidebar-user-material customers">
              <div class="category-content pt-0" style="background-color:#4D125EFF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.customers"
                    @click.prevent="toggleSection('customers')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.customers')) }}</span><span v-if="$_restWords($t('sidebar.customers'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.customers')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.customers"
              >
                <ul class="navigation" style="background-color:#601674FF;">
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_customer')"
                  to="/regular-user"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >person</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('columns.customer')) }}</span><span v-if="$_restWords($t('columns.customer'))" class="oc-nav-label-line">{{ $_restWords($t('columns.customer')) }}</span></span></a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_customer_subscription')"
                  to="/customer-subscription"
                  tag="li"
                  active-class="active"
                ><a><i style="font-size: 18px" class="material-icons">card_membership</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('addEditUserSubscription.customerSubscriptionTitle')) }}</span><span v-if="$_restWords($t('addEditUserSubscription.customerSubscriptionTitle'))" class="oc-nav-label-line">{{ $_restWords($t('addEditUserSubscription.customerSubscriptionTitle')) }}</span></span></a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_loaned_customer')"
                  to="/loan-customers"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >person</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.loanedCustomerTitle')) }}</span><span v-if="$_restWords($t('sidebar.loanedCustomerTitle'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.loanedCustomerTitle')) }}</span></span></a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_credit')"
                  to="/secret?component=credit"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >attach_money</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('user.customerCreditTitle')) }}</span><span v-if="$_restWords($t('user.customerCreditTitle'))" class="oc-nav-label-line">{{ $_restWords($t('user.customerCreditTitle')) }}</span></span></a></router-link>
                  <router-link
                    v-if="$_has_perm('view_customer_price')"
                    class="sidebar-mobile-main-toggle"
                    to="/secret?component=customer-prices"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-money"
                        style="font-size: 16px"
                      ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.customerPricesTitle')) }}</span><span v-if="$_restWords($t('sidebar.customerPricesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.customerPricesTitle')) }}</span></span></a></router-link>
                </ul>
              </div>
            </div>

            <div v-if="hasAnyReportSectionPerm" class="sidebar-user-material report">
              <div class="category-content pt-0" style="background-color:#80864DFF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.reports"
                    @click.prevent="toggleSection('reports')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.reports')) }}</span><span v-if="$_restWords($t('sidebar.reports'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.reports')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.reports"
              >
                <ul class="navigation" style="background-color:#9BA25C;">
                  <!-- <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_delivered_report')"
                    to="/delivered-report"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-line-chart pl-2"></i>Delivered Report</a></router-link> -->
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_orders_report')"
                    to="/report/orders"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-shopping-cart pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.ordersReportTitle')) }}</span><span v-if="$_restWords($t('reports.ordersReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.ordersReportTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_customers_report')"
                    to="/report/customers"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-users pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.customersReportTitle')) }}</span><span v-if="$_restWords($t('reports.customersReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.customersReportTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_invoices_report')"
                    to="/report/invoices"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-file-text pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.invoicesReportTitle')) }}</span><span v-if="$_restWords($t('reports.invoicesReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.invoicesReportTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_expenses_report')"
                    to="/report/expenses"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-money pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.expensesReportTitle')) }}</span><span v-if="$_restWords($t('reports.expensesReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.expensesReportTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_sales_report')"
                    to="/report/sales"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-shopping-cart pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.salesReportTitle')) }}</span><span v-if="$_restWords($t('reports.salesReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.salesReportTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_buys_report')"
                    to="/report/buys"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-shopping-bag pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.buysReportTitle')) }}</span><span v-if="$_restWords($t('reports.buysReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.buysReportTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_gained_report')"
                    to="/report/gained"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-line-chart pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.gainedReportTitle')) }}</span><span v-if="$_restWords($t('reports.gainedReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.gainedReportTitle')) }}</span></span></a></router-link>
                  <!-- <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_revenue_report')"
                    to="/report/revenue"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-bar-chart pl-2"></i>Revenue Report</a></router-link> -->
                  <!-- <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_order_costs_report')"
                    to="/report/order-costs"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-calculator pl-2"></i>Order Costs Report</a></router-link> -->
                  <!-- <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_profit')"
                    to="/report/profit"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-area-chart pl-2"></i>Profit Report</a></router-link> -->
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_order_status_report')"
                    to="/report/order-status"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-filter pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.orderStatusReportTitle')) }}</span><span v-if="$_restWords($t('reports.orderStatusReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.orderStatusReportTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_customer_invoices_report')"
                    to="/report/customer-invoices"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-file-text-o pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.customerInvoicesReportTitle')) }}</span><span v-if="$_restWords($t('reports.customerInvoicesReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.customerInvoicesReportTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_daily_revenue_report')"
                    to="/report/daily-revenue"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-calendar pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.dailyRevenueReportTitle')) }}</span><span v-if="$_restWords($t('reports.dailyRevenueReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.dailyRevenueReportTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_delivery_report')"
                    to="/report/delivery"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-truck pl-2"></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('reports.deliveryReportTitle')) }}</span><span v-if="$_restWords($t('reports.deliveryReportTitle'))" class="oc-nav-label-line">{{ $_restWords($t('reports.deliveryReportTitle')) }}</span></span></a></router-link>
                  <!-- <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_unpaid_received_invoices')"
                    to="/report/unpaid-received"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-exclamation-circle pl-2"></i>Unpaid Received Inv.</a></router-link> -->
                  <!-- <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_unpaid_arrived_invoices')"
                    to="/report/unpaid-arrived"
                    tag="li"
                    active-class="active"
                  ><a><i class="fa fa-exclamation-triangle pl-2"></i>Unpaid Arrived Inv.</a></router-link> -->
                </ul>
              </div>
            </div>

            <div v-if="hasAnyMobileAppSectionPerm" class="sidebar-user-material mobile-app">
              <div class="category-content pt-0" style="background-color:#C67101FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.mobileApp"
                    @click.prevent="toggleSection('mobileApp')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.mobileApp')) }}</span><span v-if="$_restWords($t('sidebar.mobileApp'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.mobileApp')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.mobileApp"
              >
                <ul class="navigation" style="background-color:#FF8F00;">
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_about')"
                    to="/about"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 16px"
                        class="fa fa-info-circle pl-2"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('mobileApp.aboutAppSectionTitle')) }}</span><span v-if="$_restWords($t('mobileApp.aboutAppSectionTitle'))" class="oc-nav-label-line">{{ $_restWords($t('mobileApp.aboutAppSectionTitle')) }}</span></span>
                    </a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_help_center')"
                    to="/help-center"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 16px"
                        class="fa fa-question-circle pl-2"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('mobileApp.helpCenterSectionTitle')) }}</span><span v-if="$_restWords($t('mobileApp.helpCenterSectionTitle'))" class="oc-nav-label-line">{{ $_restWords($t('mobileApp.helpCenterSectionTitle')) }}</span></span>
                    </a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('send_notification')"
                    to="/send-notification"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 16px"
                        class="fa fa-bell pl-2"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sendNotification.title')) }}</span><span v-if="$_restWords($t('sendNotification.title'))" class="oc-nav-label-line">{{ $_restWords($t('sendNotification.title')) }}</span></span>
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_home_banner')"
                    class="sidebar-mobile-main-toggle"
                    to="/home-banner"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-image pl-2"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('mobileApp.homeBannerTitle')) }}</span><span v-if="$_restWords($t('mobileApp.homeBannerTitle'))" class="oc-nav-label-line">{{ $_restWords($t('mobileApp.homeBannerTitle')) }}</span></span>
                    </a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_home_slider')"
                    class="sidebar-mobile-main-toggle"
                    to="/home-slider"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-image pl-2"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('mobileApp.homeSliderTitle')) }}</span><span v-if="$_restWords($t('mobileApp.homeSliderTitle'))" class="oc-nav-label-line">{{ $_restWords($t('mobileApp.homeSliderTitle')) }}</span></span>
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_popular_website')"
                    class="sidebar-mobile-main-toggle"
                    to="/popular-website"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-globe pl-2"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('mobileApp.popularWebsiteTitle')) }}</span><span v-if="$_restWords($t('mobileApp.popularWebsiteTitle'))" class="oc-nav-label-line">{{ $_restWords($t('mobileApp.popularWebsiteTitle')) }}</span></span>
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_global_website')"
                    class="sidebar-mobile-main-toggle"
                    to="/global-website-group"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-globe pl-2"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('mobileApp.globalWebsiteGroupTitle')) }}</span><span v-if="$_restWords($t('mobileApp.globalWebsiteGroupTitle'))" class="oc-nav-label-line">{{ $_restWords($t('mobileApp.globalWebsiteGroupTitle')) }}</span></span>
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_force_update')"
                    class="sidebar-mobile-main-toggle"
                    to="/force-update"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-underline pl-2"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('mobileApp.forceUpdateTitle')) }}</span><span v-if="$_restWords($t('mobileApp.forceUpdateTitle'))" class="oc-nav-label-line">{{ $_restWords($t('mobileApp.forceUpdateTitle')) }}</span></span>
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_link_rule')"
                    class="sidebar-mobile-main-toggle"
                    to="/link-rules"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        style="font-size: 16px"
                        class="fa fa-link pl-2"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('mobileApp.linksTitle')) }}</span><span v-if="$_restWords($t('mobileApp.linksTitle'))" class="oc-nav-label-line">{{ $_restWords($t('mobileApp.linksTitle')) }}</span></span>
                    </a>
                  </router-link>

                  <router-link
                    v-if="$_has_perm('view_our_address')"
                    class="sidebar-mobile-main-toggle"
                    to="/our-address"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-map-marker pl-2"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('mobileApp.ourAddressTitle')) }}</span><span v-if="$_restWords($t('mobileApp.ourAddressTitle'))" class="oc-nav-label-line">{{ $_restWords($t('mobileApp.ourAddressTitle')) }}</span></span>
                    </a>
                  </router-link>
                </ul>
              </div>
            </div>

            <div v-if="hasAnyAdminSectionPerm" class="sidebar-user-material admin">
              <div class="category-content pt-0" style="background-color:#2A4A77FF;">

                <div class="sidebar-user-material-menu mt-0">
                  <a
                    style="font-size: 15px; font-weight: bold;"
                    href="#"
                    role="button"
                    :aria-expanded="openSections.admin"
                    @click.prevent="toggleSection('admin')"
                  ><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.admin')) }}</span><span v-if="$_restWords($t('sidebar.admin'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.admin')) }}</span></span> <i class="caret"></i></a>
                </div>
              </div>

              <div
                class="navigation-wrapper"
                v-show="openSections.admin"
              >
                <ul class="navigation" style="background-color:#3261A3FF;">
                  <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_order_type')"
                  to="/order-types"
                  tag="li"
                  active-class="active"
                ><a><i style="font-size: 18px" class="material-icons">category</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.orderTypesTitle')) }}</span><span v-if="$_restWords($t('sidebar.orderTypesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.orderTypesTitle')) }}</span></span></a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_order_status_settings')"
                  to="/order-status-settings"
                  tag="li"
                  active-class="active"
                ><a><i style="font-size: 18px" class="material-icons">palette</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orderStatusSettings.title')) }}</span><span v-if="$_restWords($t('orderStatusSettings.title'))" class="oc-nav-label-line">{{ $_restWords($t('orderStatusSettings.title')) }}</span></span></a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_subscription')"
                  to="/subscription"
                  tag="li"
                  active-class="active"
                ><a><i
                      style="font-size: 18px"
                      class="material-icons"
                    >subscriptions</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('columns.subscription')) }}</span><span v-if="$_restWords($t('columns.subscription'))" class="oc-nav-label-line">{{ $_restWords($t('columns.subscription')) }}</span></span></a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_subscription_pricing')"
                  to="/subscription-pricing"
                  tag="li"
                  active-class="active"
                ><a><i style="font-size: 18px" class="material-icons">category</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('admin.subscriptionPricingTitle')) }}</span><span v-if="$_restWords($t('admin.subscriptionPricingTitle'))" class="oc-nav-label-line">{{ $_restWords($t('admin.subscriptionPricingTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_reason')"
                    to="/reason"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-ban"
                        style="font-size: 16px"
                      ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.reason')) }}</span><span v-if="$_restWords($t('orders.reason'))" class="oc-nav-label-line">{{ $_restWords($t('orders.reason')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_staff')"
                    to="/users"
                    tag="li"
                    active-class="active"
                  >
                  <a><i
                        style="font-size: 18px"
                        class="material-icons"
                      >group</i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('user.staffTitle')) }}</span><span v-if="$_restWords($t('user.staffTitle'))" class="oc-nav-label-line">{{ $_restWords($t('user.staffTitle')) }}</span></span></a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_role')"
                    class="sidebar-mobile-main-toggle"
                    to="/roles"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-shield pl-2"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('admin.rolesTitle')) }}</span><span v-if="$_restWords($t('admin.rolesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('admin.rolesTitle')) }}</span></span>
                    </a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_settings')"
                    class="sidebar-mobile-main-toggle"
                    to="/settings"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-cog"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('admin.settingsTitle')) }}</span><span v-if="$_restWords($t('admin.settingsTitle'))" class="oc-nav-label-line">{{ $_restWords($t('admin.settingsTitle')) }}</span></span>
                    </a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_coupon')"
                    to="/secret?component=coupon"
                    tag="li"
                    active-class="active"
                  >
                  <a><i
                        class="fa fa-credit-card-alt"
                        style="font-size: 16px"
                      ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('admin.couponsTitle')) }}</span><span v-if="$_restWords($t('admin.couponsTitle'))" class="oc-nav-label-line">{{ $_restWords($t('admin.couponsTitle')) }}</span></span></a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_warehouse')"
                    class="sidebar-mobile-main-toggle"
                    to="/warehouse"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-home pl-2"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('columns.warehouse')) }}</span><span v-if="$_restWords($t('columns.warehouse'))" class="oc-nav-label-line">{{ $_restWords($t('columns.warehouse')) }}</span></span>
                    </a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_governorate')"
                    class="sidebar-mobile-main-toggle"
                    to="/governorate"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-globe pl-2"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('admin.governoratesTitle')) }}</span><span v-if="$_restWords($t('admin.governoratesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('admin.governoratesTitle')) }}</span></span>
                    </a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_city')"
                    class="sidebar-mobile-main-toggle"
                    to="/city"
                    tag="li"
                    active-class="active"
                  >
                    <a>
                      <i
                        class="fa fa-home pl-2"
                        style="font-size: 16px"
                      />
                      <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('admin.citiesTitle')) }}</span><span v-if="$_restWords($t('admin.citiesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('admin.citiesTitle')) }}</span></span>
                    </a>
                  </router-link>
                  <router-link
                    v-if="$_has_perm('view_company_fee')"
                    class="sidebar-mobile-main-toggle"
                    to="/secret?component=kreenex-fee-prices"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-money"
                        style="font-size: 16px"
                      ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('admin.shipZoneFeePricesTitle')) }}</span><span v-if="$_restWords($t('admin.shipZoneFeePricesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('admin.shipZoneFeePricesTitle')) }}</span></span></a>
                  </router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    v-if="$_has_perm('view_supplier')"
                    to="/supplier"
                    tag="li"
                    active-class="active"
                  ><a><i
                        class="fa fa-users"
                        style="font-size: 16px"
                      ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('admin.suppliersTitle')) }}</span><span v-if="$_restWords($t('admin.suppliersTitle'))" class="oc-nav-label-line">{{ $_restWords($t('admin.suppliersTitle')) }}</span></span></a>
                  </router-link>
                  <router-link
              v-if="$_has_perm('view_order_log')"
              class="sidebar-mobile-main-toggle"
              to="/secret?component=order-log"
              tag="li"
              active-class="active"
            ><a>
                <i
                  style="font-size: 18px"
                  class="material-icons"
                >swap_vert</i>
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('admin.orderLogTitle')) }}</span><span v-if="$_restWords($t('admin.orderLogTitle'))" class="oc-nav-label-line">{{ $_restWords($t('admin.orderLogTitle')) }}</span></span>
              </a>
            </router-link>
                  <router-link
              v-if="$_has_perm('view_activity_log')"
              class="sidebar-mobile-main-toggle"
              to="/activity-log"
              tag="li"
              active-class="active"
            ><a>
                <i
                  style="font-size: 18px"
                  class="material-icons"
                >history</i>
                <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('admin.activityLogTitle')) }}</span><span v-if="$_restWords($t('admin.activityLogTitle'))" class="oc-nav-label-line">{{ $_restWords($t('admin.activityLogTitle')) }}</span></span>
              </a>
            </router-link>
                </ul>
              </div>
            </div>

          </ul>
        </div>
      </div>
      <!-- /main navigation for staff -->

      <!-- Main navigation for CUSTOMER -->
      <div v-if="!loggedInUserData.is_staff">
        <div
          class="sidebar-category sidebar-category-visible"
          v-if="loggedInUserData.phone_number && loggedInUserData.address"
        >
          <div class="category-content no-padding">
            <ul class="navigation navigation-main navigation-accordion">
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/make-new-ship-only"
                tag="li"
                active-class="active"
              ><a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >add</i>
                  <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('columns.shipOnly')) }}</span><span v-if="$_restWords($t('columns.shipOnly'))" class="oc-nav-label-line">{{ $_restWords($t('columns.shipOnly')) }}</span></span></a></router-link>
                  <router-link
              class="sidebar-mobile-main-toggle"
              to="/new-ship-only"
              tag="li"
              active-class="active"
                ><a> <i
                      style="font-size: 16px"
                      class="fa fa-plus"
                    /> <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.shipOnlyNewTitle')) }}</span><span v-if="$_restWords($t('sidebar.shipOnlyNewTitle'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.shipOnlyNewTitle')) }}</span></span>
                  </a></router-link>
                  <router-link
                  class="sidebar-mobile-main-toggle"
                  v-if="$_has_perm('view_all_order')"
                  to="/all-order"
                  tag="li"
                  active-class="active"
                ><a> <i
                      style="font-size: 16px"
                      class="fa fa-cubes"
                    ></i><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.allOrdersTitle')) }}</span><span v-if="$_restWords($t('orders.allOrdersTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.allOrdersTitle')) }}</span></span></a></router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/make-new-order"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >add_box</i>
                  <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('datatable.newOrderButton')) }}</span><span v-if="$_restWords($t('datatable.newOrderButton'))" class="oc-nav-label-line">{{ $_restWords($t('datatable.newOrderButton')) }}</span></span>
                </a>
              </router-link>
              <!-- Export Order hidden for later use
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/my-export-order"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="fa fa-share-square-o"
                  />
                  Export Order
                </a>
              </router-link>
              -->
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/my-order"
                tag="li"
                active-class="active"
              ><a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >filter_none</i>
                  <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.orders')) }}</span><span v-if="$_restWords($t('sidebar.orders'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.orders')) }}</span></span></a></router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/archived-order"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >
                    archive
                  </i>
                  <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('customer.archivedOrdersTitle')) }}</span><span v-if="$_restWords($t('customer.archivedOrdersTitle'))" class="oc-nav-label-line">{{ $_restWords($t('customer.archivedOrdersTitle')) }}</span></span>
                </a>
              </router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/my-order-cases"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 16px"
                    class="fa fa-folder-open"
                  />
                  <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('orders.orderCasesTitle')) }}</span><span v-if="$_restWords($t('orders.orderCasesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('orders.orderCasesTitle')) }}</span></span>
                </a>
              </router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/charge-balance"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="fa fa-money"
                  />
                  <span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.chargeBalanceTitle')) }}</span><span v-if="$_restWords($t('sidebar.chargeBalanceTitle'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.chargeBalanceTitle')) }}</span></span>
                </a>
              </router-link>
              <!-- Check Rate hidden for later use
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/check-rate"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="fa fa-calculator"
                  />
                  Check Rate
                </a>
              </router-link>
              -->
              <li>
                <a
                  href="#"
                  role="button"
                  :class="{ 'nav-collapsed': !openSections.customerInvoices }"
                  :aria-expanded="openSections.customerInvoices"
                  style="display: flex; justify-content: space-between; align-items: center; width: 100%;"
                  @click.prevent="toggleSection('customerInvoices')"
                >
                    <span><i
                    style="font-size: 18px; padding: 1px;"
                    class="material-icons"
                  >assignment</i><span style="padding: 10px 15px;" class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.invoices')) }}</span><span v-if="$_restWords($t('sidebar.invoices'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.invoices')) }}</span></span></span>
                  <i class="fa fa-angle-down mt-1" style="font-size: 16px" aria-hidden="true"></i></a>
                <ul v-show="openSections.customerInvoices">
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-invoice"
                    tag="li"
                    active-class="active"
                  ><a><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.orderInvoicesTitle')) }}</span><span v-if="$_restWords($t('sidebar.orderInvoicesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.orderInvoicesTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-order-invoice"
                    tag="li"
                    active-class="active"
                  ><a><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.shippingInvoicesTitle')) }}</span><span v-if="$_restWords($t('sidebar.shippingInvoicesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.shippingInvoicesTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-credit-invoice"
                    tag="li"
                    active-class="active"
                  ><a><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.creditInvoicesTitle')) }}</span><span v-if="$_restWords($t('sidebar.creditInvoicesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.creditInvoicesTitle')) }}</span></span></a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-partial-refund"
                    tag="li"
                    active-class="active"
                  ><a><span class="oc-nav-label"><span class="oc-nav-label-line">{{ $_firstWord($t('sidebar.partialRefundInvoicesTitle')) }}</span><span v-if="$_restWords($t('sidebar.partialRefundInvoicesTitle'))" class="oc-nav-label-line">{{ $_restWords($t('sidebar.partialRefundInvoicesTitle')) }}</span></span></a></router-link>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- /main navigation for CUSTOMER -->
    </div>
  </div>
  <!-- /main sidebar -->
</template>

<script>
import statusHelpers from '../mixins/statusHelpers'

export default {
  mixins: [statusHelpers],

  props: ['loggedInUserData', 'orderCounts'],

  data() {
    return {
      showAdminSections: false,
      allNavigationsExpanded: false,
      openSections: {
        orders: true,
        tools: false,
        export: false,
        delivery: false,
        invoices: false,
        finance: false,
        cases: false,
        customers: false,
        reports: false,
        mobileApp: false,
        admin: false,
        customerInvoices: false
      }
    }
  },

  mounted() {
    this.$_fetch_statuses()
  },

  computed: {
    // Every collapsible sidebar section's toggle header renders even when every one of its
    // sub-links is hidden by $_has_perm (e.g. a delivery-only role) — a section with nothing
    // inside it once expanded. Hide the whole section (header + body) unless at least one
    // sub-link would actually show. Keep each list in sync with the v-if list on that
    // section's own router-links below (excluding any commented-out router-links).
    hasAnyOrdersSectionPerm() {
      return [
        'view_all_order',
        'view_approved_order',
        'view_archived_order',
        'view_branch_delivered_order',
        'view_canceled_order',
        'view_damage_order',
        'view_delivered_order',
        'view_new_order',
        'view_partial_refund',
        'view_pending_answer_order',
        'view_pending_to_branch',
        'view_pending_to_shipment_order',
        'view_processed_order',
        'view_purchased_order',
        'view_refunded_order',
        'view_return_order',
        'view_ship_only',
        'view_shipment_order',
        'view_warehouse_delivered_order'
      ].some((code) => this.$_has_perm(code))
    },

    // Moved out of Orders into their own "Tools" category: exportable orders, warehouse
    // date-passed, not-found orders, purchase history -- all secondary/reference views
    // rather than order-status stages, matching the same hasAnyXSectionPerm pattern used
    // for every other category.
    hasAnyToolsSectionPerm() {
      return [
        'view_exportable_order',
        'view_warehouse_passed_order',
        'view_not_found_order',
        'view_purchase_history'
      ].some((code) => this.$_has_perm(code))
    },

    hasAnyExportOrderSectionPerm() {
      return [
        'view_approved_export_order',
        'view_canceled_export_order',
        'view_export_history',
        'view_export_order',
        'view_export_order_refund',
        'view_processed_export_order',
        'view_received_export_order',
        'view_sent_export_order'
      ].some((code) => this.$_has_perm(code))
    },

    hasAnyDeliverySectionPerm() {
      return ['view_order_delivery'].some((code) => this.$_has_perm(code))
    },

    hasAnyInvoicesSectionPerm() {
      return [
        'view_credit',
        'view_delivery_invoice',
        'view_order_invoice',
        'view_shipping_invoice'
      ].some((code) => this.$_has_perm(code))
    },

    hasAnyFinanceSectionPerm() {
      return [
        'view_bank',
        'view_bank_transaction',
        'view_capital',
        'view_currency_rate',
        'view_expense',
        'view_expense_type',
        'view_money_transfer',
        'view_profit'
      ].some((code) => this.$_has_perm(code))
    },

    hasAnyCasesSectionPerm() {
      return [
        'view_order_case',
        'view_progress_order_case'
      ].some((code) => this.$_has_perm(code))
    },

    hasAnyCustomersSectionPerm() {
      return [
        'view_credit',
        'view_customer',
        'view_customer_price',
        'view_customer_subscription',
        'view_loaned_customer'
      ].some((code) => this.$_has_perm(code))
    },

    hasAnyReportSectionPerm() {
      return [
        'view_orders_report',
        'view_customers_report',
        'view_invoices_report',
        'view_expenses_report',
        'view_sales_report',
        'view_buys_report',
        'view_gained_report',
        'view_order_status_report',
        'view_customer_invoices_report',
        'view_daily_revenue_report',
        'view_delivery_report'
      ].some((code) => this.$_has_perm(code))
    },

    hasAnyMobileAppSectionPerm() {
      return [
        'send_notification',
        'view_about',
        'view_force_update',
        'view_global_website',
        'view_help_center',
        'view_home_banner',
        'view_home_slider',
        'view_link_rule',
        'view_our_address',
        'view_popular_website'
      ].some((code) => this.$_has_perm(code))
    },

    hasAnyAdminSectionPerm() {
      return [
        'view_order_type',
        'view_order_status_settings',
        'view_subscription',
        'view_subscription_pricing',
        'view_reason',
        'view_staff',
        'view_role',
        'view_settings',
        'view_coupon',
        'view_warehouse',
        'view_governorate',
        'view_city',
        'view_company_fee',
        'view_supplier',
        'view_order_log',
        'view_activity_log'
      ].some((code) => this.$_has_perm(code))
    }
  },

  methods: {
    toggleSection(key) {
      this.openSections[key] = !this.openSections[key]
    },
    toggleAllNavigations() {
      this.allNavigationsExpanded = !this.allNavigationsExpanded
      const expanded = this.allNavigationsExpanded
      Object.keys(this.openSections).forEach(key => {
        this.openSections[key] = expanded
      })
    },

    // Route label line-break: first word on its own line, remaining word(s) together on
    // the next -- e.g. "Pending Answer" -> "Pending" / "Answer", "Warehouse Delivered
    // Order" -> "Warehouse" / "Delivered Order". Used with .oc-nav-label (flex-direction:
    // column) below rather than a <br>, since <br> inside a flex row (this component's
    // existing .navigation li > a display:flex) isn't reliably respected by browsers for
    // line-breaking -- nested flex (row containing a column) is the robust way to do it.
    $_firstWord(label) {
      if (!label) return ''
      return label.trim().split(/\s+/)[0] || ''
    },
    $_restWords(label) {
      if (!label) return ''
      return label.trim().split(/\s+/).slice(1).join(' ')
    }
  }
}
</script>
<style>
/* .sidebar-content intentionally has no height/overflow rule anymore -- matches
   pageContainer.vue's .panel-flat fix: the sidebar now grows to fit every route link and
   scrolls together with the rest of the page as one region, instead of clipping its own
   lower links behind a second, separate scrollbar once the page itself became
   scrollable. (Previously: height: 94vh; overflow: scroll;) */
.group-title {
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  opacity: 0.8;
  padding: 6px 8px;
  margin-top: 8px;
  letter-spacing: 1.1px;
}

.navigation {
  padding: 0 !important;
}

.toggle-nav-btn {
  width: 100%;
  padding: 10px 15px;
  border: none;
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  border-radius: 3px;
  cursor: pointer;
}

.toggle-nav-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.toggle-nav-btn:active {
  background-color: rgba(255, 255, 255, 0.15);
}
.nav-collapsed .fa-angle-down {
  transform: rotate(-90deg);
  transition: transform 0.2s ease;
}

.fa-angle-down {
  transition: transform 0.2s ease;
}

.fa-caret-down {
  transition: transform 0.2s ease;
}

.fa-caret-down.rotated {
  transform: rotate(180deg);
}

.toggle-nav-btn {
  width: 100%;
  padding: 10px 15px;
  border: none;
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  border-radius: 3px;
  cursor: pointer;
}

.toggle-nav-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.toggle-nav-btn:active {
  background-color: rgba(255, 255, 255, 0.15);
}

.bg {
  height: 150px;
  width: 220px;
}

.fit-img {
  width: 62%;
  height: 90%;
}

/* .sidebar-content intentionally has no height/overflow rule anymore -- matches
   pageContainer.vue's .panel-flat fix: the sidebar now grows to fit every route link and
   scrolls together with the rest of the page as one region, instead of clipping its own
   lower links behind a second, separate scrollbar once the page itself became
   scrollable. (Previously: height: 94vh; overflow: scroll;) */

.group-title {
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  opacity: 0.8;
  padding: 6px 8px;
  margin-top: 8px;
  letter-spacing: 1.1px;
}

.navigation {
  padding: 0 !important;
}

.pending-boat-icon {
  position: relative;
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.pending-boat-icon .boat-base {
  font-size: 24px;
  line-height: 24px;
}
.pending-boat-icon .boat-badge {
  position: absolute;
  bottom: -4px;
  right: -6px;
  font-size: 14px;
  background: #fff;
  color: #ff9800; /* pending color */
  border-radius: 50%;
  padding: 2px;
  box-shadow: 0 0 0 1px #ddd;
}

.order-badge {
  flex-shrink: 0;
  background-color: #337ab7;
  color: #fff;
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
  line-height: 1.4;
  margin-left: auto;
  padding-left: 6px;
}

.order-badge--green {
  background-color: #5cb85c;
}

/* Override the framework's dark-badge rule on active nav items */
.navigation > li.active > a .order-badge,
.navigation li.active > a .order-badge {
  background-color: #337ab7;
  border-color: transparent;
}

.navigation > li.active > a .order-badge--green,
.navigation li.active > a .order-badge--green {
  background-color: #5cb85c;
}

@media (min-width: 769px) {
  /* Narrowed from 245px now that multi-word labels wrap onto their own lines (see
     $_firstWord/$_restWords + .oc-nav-label above) instead of needing full single-line
     width. Tested against the longest real labels (e.g. "Subscription", "Governorates",
     "Warehouse" / "Delivered Order") down to 170px with no overflow; kept a bit more
     margin here since Arabic/Kurdish translations of the same labels weren't tested and
     may run longer than the English source strings. */
  .sidebar-admin {
    width: 200px;
  }
}

.sidebar-admin .navigation li > a {
  display: flex;
  align-items: center;
  gap: 4px;
}

.sidebar-admin .navigation li > a > i,
.sidebar-admin .navigation li > a > span.pending-boat-icon,
.sidebar-admin .navigation li > a > span.badge {
  flex-shrink: 0;
}

/* Route label: first word on its own line, remaining word(s) on the next -- see
   $_firstWord/$_restWords above. Nested flex (this row-flex <a> containing a
   flex-direction: column child) is what actually produces the line break, since a plain
   <br> between flex items isn't reliably respected as a line break by browsers. min-width:
   0 is needed because flex items default to min-width: auto, which would otherwise clamp
   this to its own single-line content width.
   inline-flex, not flex: category headers (.sidebar-user-material-menu > a) are
   display:block with their .caret floated right (float: right in components.css) --
   a plain flex (block-level) box here would sit on its own line, pushing that float below
   it entirely instead of beside it. inline-flex keeps the label inline-level from the
   outside (so it coexists with the float on the same line) while still stacking its own
   two lines internally via flex-direction: column. Confirmed by testing in isolation --
   with `flex`, the caret rendered ~25px below the label instead of next to it. */
.oc-nav-label {
  display: inline-flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
}
.oc-nav-label-line {
  white-space: normal;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue